import Box from "@mui/material/Box";

/**
 * "Skip to main content" link — the first tabbable element on every page.
 *
 * Keyboard and screen-reader users otherwise have to tab through the entire
 * sidebar and navbar on every page before reaching the content. Visually
 * hidden until it receives keyboard focus (the standard pattern), then shown
 * as a small pill in the top-left. Targets the layout's <main id="main-content">.
 */
const SkipToContent = () => (
  <Box
    component="a"
    href="#main-content"
    sx={{
      position: "absolute",
      top: 8,
      left: 8,
      zIndex: 2000,
      padding: "8px 16px",
      borderRadius: "8px",
      backgroundColor: "#017C76",
      color: "#ffffff",
      fontWeight: 700,
      fontSize: "0.875rem",
      textDecoration: "none",
      // Visually hidden until focused, but always in the tab order.
      transform: "translateY(-200%)",
      "&:focus-visible": {
        transform: "translateY(0)",
        outline: "2px solid #ffffff",
        outlineOffset: "2px",
      },
    }}
  >
    Skip to main content
  </Box>
);

export default SkipToContent;
